import { Icon, IconButton } from '@elipssolution/harfang';
import { mdiArrowExpand } from '@mdi/js';
import { Paper, Stack, Typography, styled } from '@mui/material';
import { useCallback, useMemo } from 'react';

import { WidgetWithKeyType } from '../../../../types/widget';
import useCustomRouter from '../../../hooks/useCustomRouter';
import { getWidgetTemplateByType } from '../../../widgets/widgets';

const StyledDashboardItem = styled(Paper)(({ theme: { palette, shape } }) => ({
	border: `1px solid ${palette.divider}`,
	borderRadius: shape.borderRadius * 2,
	display: 'flex',
	flexDirection: 'column',
	overflow: 'hidden',
	width: '100%',
	height: '100%',
}));

type MobileDashboardItemProps = {
	widgetWithKey: WidgetWithKeyType;
};

const MobileDashboardItem = ({ widgetWithKey }: MobileDashboardItemProps) => {
	const { widget } = widgetWithKey;
	const { push, query } = useCustomRouter();
	const { name, type, configuration } = widget;
	const { component: WidgetComponent, expandedComponent } = getWidgetTemplateByType(type);

	const parsedConfiguration = useMemo(
		() => (configuration ? (JSON.parse(configuration) as object) : undefined),
		[configuration],
	);

	const handleNavigateToWidget = useCallback(() => {
		push({ pathname: 'widget', query: { ...query, name, type, ...(configuration && { configuration }) } }).catch(
			(error) => {
				throw error;
			},
		);
	}, [configuration, name, push, query, type]);

	return (
		<StyledDashboardItem>
			<Stack direction="row">
				<Typography padding={1} flex={1} variant="h6" fontSize="18px" noWrap>
					{name}
				</Typography>

				{expandedComponent && (
					<IconButton onClick={handleNavigateToWidget}>
						<Icon path={mdiArrowExpand} />
					</IconButton>
				)}
			</Stack>

			<Stack flex={1} padding={1} paddingTop={0}>
				<WidgetComponent widgetWithKey={widgetWithKey} configuration={parsedConfiguration} readOnly={false} />
			</Stack>
		</StyledDashboardItem>
	);
};

export default MobileDashboardItem;
